import { forwardRef } from 'react';
import type { HTMLAttributes } from 'react';
import { twMerge as cn } from 'tailwind-merge';

export const OnboardingSurface = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(function OnboardingSurface({ className, ...rest }, ref) {
  return (
    <div
      ref={ref}
      className={cn(
        'box-border rounded-xl border border-gray-300 bg-white shadow-card',
        className,
      )}
      {...rest}
    />
  );
});

export const OnboardingNestedPanel = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(function OnboardingNestedPanel({ className, ...rest }, ref) {
  return (
    <div
      ref={ref}
      className={cn(
        'rounded-lg border border-gray-300 bg-white shadow-panel',
        className,
      )}
      {...rest}
    />
  );
});
